import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { api, CATEGORIES } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";
import { Page } from "@/components/Page";

const sel = "h-11 rounded-full border border-white/10 bg-[#121215] px-4 text-sm outline-none focus:border-[#D4AF37]/60";

export default function Catalog() {
  const [items, setItems] = useState([]);
  const [brands, setBrands] = useState([]);
  const [f, setF] = useState({ q: "", category: "", brand: "", gender: "alle" });

  useEffect(() => { api.get("/products/brands").then(({ data }) => setBrands(data)); }, []);
  useEffect(() => {
    const params = Object.fromEntries(Object.entries(f).filter(([, v]) => v));
    const t = setTimeout(() => api.get("/products", { params }).then(({ data }) => setItems(data)), 250);
    return () => clearTimeout(t);
  }, [f]);

  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  return (
    <Page over="Partner-Marken" title="Entdecke Teile vieler Marken" sub="Alle Teile kannst du im Outfit Builder kombinieren. Über „Zum Shop“ gelangst du direkt zum Partner-Shop." testid="catalog-page">
      <div className="mb-10 flex flex-wrap gap-3">
        <div className="relative min-w-[220px] flex-1">
          <Search className="absolute left-4 top-3.5 h-4 w-4 text-neutral-500" />
          <input value={f.q} onChange={set("q")} placeholder="Suche nach Teil oder Marke" className={`${sel} w-full pl-11`} data-testid="catalog-search-input" />
        </div>
        <select value={f.gender} onChange={set("gender")} className={sel} data-testid="catalog-gender-filter">
          <option value="alle">Alle</option><option value="damen">Damen</option><option value="herren">Herren</option>
        </select>
        <select value={f.category} onChange={set("category")} className={sel} data-testid="catalog-category-filter">
          <option value="">Alle Kategorien</option>{CATEGORIES.map((c) => <option key={c}>{c}</option>)}
        </select>
        <select value={f.brand} onChange={set("brand")} className={sel} data-testid="catalog-brand-filter">
          <option value="">Alle Marken</option>{brands.map((b) => <option key={b}>{b}</option>)}
        </select>
      </div>
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4" data-testid="catalog-grid">
        {items.map((p) => <ProductCard key={p.id} p={p} />)}
      </div>
      {items.length === 0 && <p className="py-16 text-center text-neutral-500" data-testid="catalog-empty">Keine Teile gefunden.</p>}
      <p className="mt-12 text-xs text-neutral-600">* Affiliate-Links: vyne erhält bei Käufen eine Provision, der Preis bleibt für dich gleich.</p>
    </Page>
  );
}
